import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';
import {ISharedNote} from '@app-types/websocket/sharedinfo.types';
import {localDel, localSave} from './sharednote.actions';

const defaultState:{sharedNotes:ISharedNote[], order:number[], localSaves:ISharedNote[]} = {
  sharedNotes : [],
  order:[],
  localSaves : [],
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

// Persisted state and server payloads can carry null entries or non-array
// shapes; only trust well-formed notes.
const asNoteArray = (notes: any): ISharedNote[] => {
  return Array.isArray(notes) ? notes.filter((note) => note && typeof note === "object") : [];
};

reducer
  .on(localSave, (state:any, payload:any) => {
    if (!payload || typeof payload !== "object") {
      return state;
    }

    const localSaves:ISharedNote[] = asNoteArray(state.localSaves);

    const index = localSaves.findIndex((note) => note.noteId === payload.noteId);
    if (index === -1) {
      localSaves.unshift(payload);
    } else {
      localSaves[index] = payload;
    }
    return {
      ...state,
      localSaves
    };
  })
  .on(localDel, (state:any, payload:any) => {

    const localSaves:ISharedNote[] = asNoteArray(state.localSaves);
    const index = localSaves.findIndex((note) => note.noteId === payload);

    if (index !== -1) {
      localSaves.splice(index,1);
    }

    return {
      ...state,
      localSaves
    };
  })
  .on(commonWebSocket.replace.SHARED_NOTE_UPDATE, (state:any, payload:any) => {
    if (!Array.isArray(payload?.sharedNotes)) {
      return state;
    }

    const sharedNotes:ISharedNote[] = asNoteArray(state.sharedNotes);

    for (const sn of payload.sharedNotes) {
      if (!sn || typeof sn !== "object") {
        continue;
      }
      const newSharedNote:ISharedNote = sn;
      const index = sharedNotes.findIndex((note) => note.noteId === newSharedNote.noteId);
      if (index === -1) {
        sharedNotes.unshift(newSharedNote);
      } else {
        sharedNotes[index] = newSharedNote;
      }
    }

    sharedNotes.sort((a,b) => {if (a.lastUpdate && b.lastUpdate) {return b.lastUpdate - a.lastUpdate} return 0 })
    return {
      ...state,
      sharedNotes
    };
  })
  .on(commonWebSocket.special.SHARED_NOTE_REMOVED, (state:any, payload:any) => {


    const sharedNotes:ISharedNote[] = asNoteArray(state.sharedNotes);
    const index = sharedNotes.findIndex((note) => note.noteId === payload.removedNote);

    if (index !== -1) {
      sharedNotes.splice(index,1);
    }

    return {
      ...state,
      sharedNotes
    };
  })
  .on(commonWebSocket.snapshot.SHARED_NOTE_ORDER_SNAPSHOT, (state: any, payload: any) => {

    const shared:number[]|undefined = Array.isArray(payload?.sharedNoteOrder) ? payload.sharedNoteOrder : undefined;

    if (shared === undefined) {
      return state;
    }

    const oldSharedNotes:ISharedNote[] = asNoteArray(state.sharedNotes);
    const sharedNotes:ISharedNote[] = [];


    for (const sn of oldSharedNotes) {
      const newSharedNote:ISharedNote = sn;
      if (shared.indexOf(newSharedNote.noteId) >= 0) {
        sharedNotes.push(newSharedNote);
      }
    }

    sharedNotes.sort((a,b) => {if (a.lastUpdate && b.lastUpdate) {return b.lastUpdate - a.lastUpdate} return 0 })
    return {
      ...state,
      sharedNotes
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/sharednote/sharednote.reducer.ts